const icons = {
  mobile: "phone",
  landline: "landline"
};
export const getIconByServiceName = serviceName => icons[serviceName];
